import { useEffect, useState, MutableRefObject } from 'react';
import * as Cesium from 'cesium';

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

function formatJulianDate(jd: Cesium.JulianDate): string {
  const d = Cesium.JulianDate.toDate(jd);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
}

/**
 * Reads the Cesium viewer's simulation clock every 100 ms and returns a
 * formatted UTC time string (HH:MM:SS). Falls back to the real wall-clock
 * UTC time before the viewer is mounted.
 */
export function useCesiumClock(
  viewerRef: MutableRefObject<Cesium.Viewer | null>,
): string {
  const [time, setTime] = useState<string>(() => {
    const d = new Date();
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
  });

  useEffect(() => {
    const id = setInterval(() => {
      const v = viewerRef.current;
      if (v) {
        setTime(formatJulianDate(v.clock.currentTime));
      } else {
        const d = new Date();
        setTime(`${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`);
      }
    }, 100);
    return () => clearInterval(id);
  }, [viewerRef]);

  return time;
}
